import React, { useState } from 'react';

import notification from './../../../../assets/images/svg/074-notification-1.svg';
import alarm from './../../../../assets/images/svg/073-alarm-1.svg';
import mail from './../../../../assets/images/svg/075-mail.svg';

export const SettingsNotifications = () => {
    const [autoriserAlert, setautoriserAlert] = useState(undefined);
    return (
        <React.Fragment>
            <div className="auto-view py-3 pb-lg-0">
                <div className="container-fluid">
                    <form className="block" noValidate >
                        <section className="block pb-sm">
                            <h4 className="h4 text-uppercase text-secondary font-weight-bolder my-2 mb-0">notifications</h4>
                            <div className="custom-control custom-checkbox custom-control-inline mr-6">
                                <input required type="checkbox" id="Autoriseremail" name="Autoriseremail" className="custom-control-input" />
                                <label className="custom-control-label rounded-sm" htmlFor="Autoriseremail">Autoriser l'envoi d'e-mails</label>
                            </div>
                        </section>
                        <section className="block">
                            <h4 className="h4 text-uppercase text-secondary font-weight-bolder my-2 mb-0">Gestion automatisée des relances et actions</h4>
                            <div className="custom-control custom-checkbox custom-control-inline mr-6 mb-4">
                                <input required type="checkbox" id="Autoriseralert" name="Autoriseralert" className="custom-control-input" defaultChecked={autoriserAlert ? true : false} />
                                <label className="custom-control-label rounded-sm" htmlFor="Autoriseralert" onClick={() => {
                                    setautoriserAlert(!autoriserAlert);
                                }}>Envoyer une alerte automatique au référent</label>
                            </div>
                            {autoriserAlert ?
                                <React.Fragment>
                                    <div className="form-group">
                                        <label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">Choisir le type d'alerte</label>
                                        <div className="grid grid-sm-narrow grid-md-3 grid-xl-auto mt-2">
                                            <div className="card picker-card aling-items-center text-center">
                                                <div className="card-header pt-sm pb-0">
                                                    <img className="img-fluid m-auto my-3 mb-2 py-1 h-gutter" src={notification} alt="notification" />
                                                </div>
                                                <div className="card-body pb-sm pt-xs">
                                                    <h5 className="h5 font-weight-demi text-uppercase">alerte de plate-forme</h5>
                                                    <p className="h6 mb-0 px-xl-5">Proin fermentum leo vel orci porta non pulvinar. </p>
                                                </div>
                                            </div>
                                            <div className="card picker-card aling-items-center text-center">
                                                <div className="card-header pt-sm pb-0">
                                                    <img className="img-fluid m-auto my-3 mb-2 py-1 h-gutter" src={alarm} alt="alarm" />
                                                </div>
                                                <div className="card-body pb-sm pt-xs">
                                                    <h5 className="h5 font-weight-demi text-uppercase">message de téléphone mobile</h5>
                                                    <p className="h6 mb-0 px-xl-5">Proin fermentum leo vel orci porta non pulvinar. </p>
                                                </div>
                                            </div>
                                            <div className="card picker-card aling-items-center text-center">
                                                <div className="card-header pt-sm pb-0">
                                                    <img className="img-fluid m-auto my-3 mb-2 py-1 h-gutter" src={mail} alt="mail" />
                                                </div>
                                                <div className="card-body pb-sm pt-xs">
                                                    <h5 className="h5 font-weight-demi text-uppercase">envoi de email</h5>
                                                    <p className="h6 mb-0 px-xl-5">Proin fermentum leo vel orci porta non pulvinar. </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="Messageprédéfini" className="label my-auto h6 font-weight-bold">Message prédéfini</label>
                                        <textarea className="form-control h-lg" placeholder="" id="Messageprédéfini" name="Messageprédéfini"></textarea>
                                    </div>
                                    <div className="form-group container-tiny">
                                        <label className="h6 font-weight-bolder my-auto" htmlFor="jours">Jours à l'avance</label>
                                        <select className="custom-select" id="jours" tabIndex={-98}>
                                            <option key={1} value={"7"}>7 jours</option>
                                        </select>
                                    </div>
                                </React.Fragment>
                                : ''
                            }
                        </section>
                    </form>
                </div>
            </div>
            <div className="container-fluid">
                <footer className="flex-md-row align-items-center mt-auto mb-sm w-100">
                    <button className="btn btn-info" >Sauvegarder</button>
                    <h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
                </footer>
            </div>
        </React.Fragment>
    )
};